<template>
  <div v-if="allAddonData.length" class="addon">
    <slot name="title">
      <h3 class="addon-title">超值加購</h3>
    </slot>
    <template v-if="cartHasMarketItem">
      <slot name="added">
        <p class="addon-check-info">購物車已有指定商品 歡迎加購以下物品</p>
      </slot>
    </template>
    <template v-if="!cartHasMarketItem && addonWarnText">
      <slot name="not-add">
        <p class="addon-check-info pb-1">還未符合加價購條件 請將主商品加入購物車</p>
      </slot>
    </template>

    <AddonItems
      :addon-data="mapAddon"
      :data-is-load="dataIsLoad"
      :has-main-item="cartHasMarketItem"
      :image-size="imageSize"
      :show-outside-info="showOutsideInfo"
      @showPopupDetail="getPopupDetail"
      @showAddonWarnText="addonWarnText = true"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import $ from 'jquery';

import useMiniCartStore from '@global/stores/useMiniCartStore';
import useAddonMappingSpec from '@global/composable/addon/useAddon';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

import AddonItems from '@global/components/addon/parts/AddonItems.vue';

const miniCartStore = useMiniCartStore();
const modalStore = useModalStore();
const { openModal } = modalStore;
const { getAddonEvent } = useAxiosAPI();
const { temperaturesData } = storeToRefs(miniCartStore);

const props = defineProps({
  marketId: {
    type: String,
    required: true,
  },
  imageSize: {
    type: String,
    required: true,
  },
  showOutsideInfo: {
    type: Boolean,
    default: false,
  },
});

const cartHasMarketItem = ref(false);
const allAddonData = ref([]);
const mapAddon = ref([]);
const addonCheck = ref([]);
const dataIsLoad = ref(false);
const detailData = ref({});
const addonWarnText = ref(false);

/**
 * @description 比對購物車內是否有賣場商品，
 * 如果有賣場商品且不是預購商品即可購買加價購商品
 */
function getShoppingData() {
  temperaturesData.value.forEach((element) => {
    element.Markets.forEach((market) => {
      const shoppingCartMarketID = market.CustomMarketID.substring(
        0,
        market.CustomMarketID.indexOf('CL'),
      );
      if (shoppingCartMarketID === props.marketId) {
        cartHasMarketItem.value = true;
      }
    });
  });
}

/**
 * @description 將相同賣場ID商品集合
 */
function getNewData() {
  addonCheck.value = allAddonData.value.map((item) => ({
    ...item,
    isCheck: false,
  }));

  mapAddon.value = useAddonMappingSpec(addonCheck.value);
  dataIsLoad.value = true;
}

/**
 * @description 取得賣場單文頁的加價購商品
 * @param {Number} marketID 賣場ID
 */
function getAllAddonData(marketID) {
  getAddonEvent({
    params: {
      MarketID: marketID,
    },
  })
    .then((res) => {
      if (res.data.Response.length) {
        allAddonData.value = res.data.Response[0].Markets;
        getNewData();
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

/**
 * @description 取得賣場popup詳細資料
 */
function getPopupDetail(payLoad) {
  detailData.value = payLoad.detailData;

  window.setTimeout(() => {
    openModal('AddonDetailPopup', detailData.value);
  }, 100);
}

watch(
  temperaturesData,
  (newVal) => {
    getShoppingData();
  },
  { immediate: true },
);

const IDNumber = props.marketId?.substring(4);
getAllAddonData(IDNumber);
</script>
